import { InjectionToken, TemplateRef, Input, Directive, ContentChildren, Component, Optional, Inject, Injectable, QueryList, EventEmitter, ViewChild, Output, HostListener, ContentChild, NgModule } from '@angular/core';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { Subject, BehaviorSubject, Subscription, of } from 'rxjs';
import { switchMap, debounceTime, filter, map, scan } from 'rxjs/operators';
import { __decorate, __param } from 'tslib';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTable, MatColumnDef, MatTableModule } from '@angular/material/table';
import { NgModel, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatLineModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule } from '@ngx-translate/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/cdk/layout';
import * as ɵngcc3 from '@angular/material/button';
import * as ɵngcc4 from '@angular/material/icon';
import * as ɵngcc5 from '@angular/material/progress-spinner';
import * as ɵngcc6 from '@ngx-translate/core';
import * as ɵngcc7 from '@angular/material/table';
import * as ɵngcc8 from '@angular/material/paginator';
import * as ɵngcc9 from '@angular/material/form-field';
import * as ɵngcc10 from '@angular/material/input';
import * as ɵngcc11 from '@angular/forms';
import * as ɵngcc12 from '@angular/material/checkbox';
import * as ɵngcc13 from '@angular/material/list';
import * as ɵngcc14 from '@angular/material/core';
import * as ɵngcc15 from '@angular/material/select';

const _c0 = function (a0) { return { data: a0 }; };
const _c1 = function (a0) { return { $implicit: a0 }; };
function GridViewComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementContainer(2, 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tile_r99 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r100 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("classList", tile_r99.classes || "")("ngClass", ctx_r100.getColspanClasses(tile_r99));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r100.gridTemplateMap[tile_r99.templateKey])("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c1, ɵngcc0.ɵɵpureFunction1(4, _c0, tile_r99.data)));
} }
function GridViewComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, GridViewComponent_ng_container_2_ng_container_1_Template, 3, 8, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tile_r99 = ctx.$implicit;
    const ctx_r98 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tile_r99 && ctx_r98.gridTemplateMap[tile_r99 == null ? null : tile_r99.templateKey]);
} }
function ButtonComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ButtonComponent_ng_template_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ButtonComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵtemplate(1, ButtonComponent_ng_template_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = ɵngcc0.ɵɵnextContext();
    const _r107 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵproperty("type", ctx_r104.type)("disabled", ctx_r104.disabled || ctx_r104.loading)("color", ctx_r104.color);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r107);
} }
function ButtonComponent_ng_template_5_button_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ButtonComponent_ng_template_5_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵtemplate(1, ButtonComponent_ng_template_5_button_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r110 = ɵngcc0.ɵɵnextContext(2);
    const _r107 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵclassProp("label-only", ctx_r110.hideIcon);
    ɵngcc0.ɵɵproperty("type", ctx_r110.type)("disabled", ctx_r110.disabled || ctx_r110.loading)("color", ctx_r110.color);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r107);
} }
function ButtonComponent_ng_template_5_button_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ButtonComponent_ng_template_5_button_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵtemplate(1, ButtonComponent_ng_template_5_button_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r111 = ɵngcc0.ɵɵnextContext(2);
    const _r107 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵclassProp("label-only", ctx_r111.hideIcon);
    ɵngcc0.ɵɵproperty("type", ctx_r111.type)("disabled", ctx_r111.disabled || ctx_r111.loading)("color", ctx_r111.color);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r107);
} }
function ButtonComponent_ng_template_5_button_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ButtonComponent_ng_template_5_button_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵtemplate(1, ButtonComponent_ng_template_5_button_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r112 = ɵngcc0.ɵɵnextContext(2);
    const _r107 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵclassProp("label-only", ctx_r112.hideIcon);
    ɵngcc0.ɵɵproperty("type", ctx_r112.type)("disabled", ctx_r112.disabled || ctx_r112.loading)("color", ctx_r112.color);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r107);
} }
function ButtonComponent_ng_template_5_button_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ButtonComponent_ng_template_5_button_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵtemplate(1, ButtonComponent_ng_template_5_button_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r113 = ɵngcc0.ɵɵnextContext(2);
    const _r107 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵclassProp("label-only", ctx_r113.hideIcon);
    ɵngcc0.ɵɵproperty("type", ctx_r113.type)("disabled", ctx_r113.disabled || ctx_r113.loading)("color", ctx_r113.color);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r107);
} }
function ButtonComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 7);
    ɵngcc0.ɵɵtemplate(1, ButtonComponent_ng_template_5_button_1_Template, 2, 6, "button", 8);
    ɵngcc0.ɵɵtemplate(2, ButtonComponent_ng_template_5_button_2_Template, 2, 6, "button", 9);
    ɵngcc0.ɵɵtemplate(3, ButtonComponent_ng_template_5_button_3_Template, 2, 6, "button", 10);
    ɵngcc0.ɵɵtemplate(4, ButtonComponent_ng_template_5_button_4_Template, 2, 6, "button", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r106 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r106.mode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "stroked");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "raised");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "flat");
} }
function ButtonComponent_ng_template_7_mat_icon_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r118 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r118.prefix + ctx_r118.actionName + ctx_r118.iconSuffix));
} }
function ButtonComponent_ng_template_7_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 20);
    ɵngcc0.ɵɵelement(1, "mat-spinner", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r119 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("color", ctx_r119.color);
} }
function ButtonComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ButtonComponent_ng_template_7_mat_icon_0_Template, 3, 3, "mat-icon", 16);
    ɵngcc0.ɵɵelementStart(1, "span", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, ButtonComponent_ng_template_7_span_4_Template, 2, 1, "span", 18);
} if (rf & 2) {
    const ctx_r108 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r108.hideIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("uppercase", ctx_r108.uppercase);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 5, ctx_r108.prefix + ctx_r108.actionName + ctx_r108.labelSuffix));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r108.loading);
} }
const _c2 = ["filter"];
function TableViewComponent_mat_form_field_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-form-field");
    ɵngcc0.ɵɵelementStart(1, "mat-label");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "mat-icon", 17);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 18, 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r120 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r120.config.actions.filter.label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r120.config.actions.filter.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r120.dataSource.filterValue);
} }
function TableViewComponent_ant_column_selection_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ant-column-selection", 20);
} if (rf & 2) {
    const ctx_r121 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("label", ctx_r121.config.labels.displayedColumns)("columnHolder", ctx_r121.columnHolder);
} }
function TableViewComponent_th_10_Template(rf, ctx) { if (rf & 1) {
    const _r132 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 21);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵelementStart(2, "mat-checkbox", 23);
    ɵngcc0.ɵɵlistener("change", function TableViewComponent_th_10_Template_mat_checkbox_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r132); const ctx_r131 = ɵngcc0.ɵɵnextContext(); return $event ? ctx_r131.masterToggle() : null; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r122 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("checked", ctx_r122.selection.hasValue() && ctx_r122.isAllSelected())("indeterminate", ctx_r122.selection.hasValue() && !ctx_r122.isAllSelected());
} }
function TableViewComponent_td_11_Template(rf, ctx) { if (rf & 1) {
    const _r135 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 24);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵelementStart(2, "mat-checkbox", 25);
    ɵngcc0.ɵɵlistener("click", function TableViewComponent_td_11_Template_mat_checkbox_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); return $event.stopPropagation(); })("change", function TableViewComponent_td_11_Template_mat_checkbox_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r135); const row_r133 = ctx.$implicit; const ctx_r136 = ɵngcc0.ɵɵnextContext(); return $event ? ctx_r136.selection.toggle(row_r133) : null; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r133 = ctx.$implicit;
    const ctx_r123 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("checked", ctx_r123.selection.isSelected(row_r133));
} }
function TableViewComponent_td_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 26);
    ɵngcc0.ɵɵelementStart(1, "mat-hint", 27);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r124 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("colSpan", ctx_r124.displayingColumns.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r124.config.labels.noResults);
} }
function TableViewComponent_td_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 26);
    ɵngcc0.ɵɵelementStart(1, "div", 28);
    ɵngcc0.ɵɵelement(2, "mat-spinner", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r125 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("colSpan", ctx_r125.displayingColumns.length);
} }
function TableViewComponent_tr_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 30);
} }
function TableViewComponent_tr_18_Template(rf, ctx) { if (rf & 1) {
    const _r139 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 31);
    ɵngcc0.ɵɵlistener("click", function TableViewComponent_tr_18_Template_tr_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r139); const item_r137 = ctx.$implicit; const ctx_r138 = ɵngcc0.ɵɵnextContext(); return ctx_r138.onShowClick(item_r137); })("contextmenu", function TableViewComponent_tr_18_Template_tr_contextmenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r139); const item_r137 = ctx.$implicit; const ctx_r140 = ɵngcc0.ɵɵnextContext(); return ctx_r140.onRightClick($event, item_r137); });
    ɵngcc0.ɵɵelementEnd();
} }
function TableViewComponent_tr_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 32);
} if (rf & 2) {
    const ctx_r128 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("hide", (ctx_r128.dataSource == null ? null : ctx_r128.dataSource.maxCount) > 0);
} }
function TableViewComponent_tr_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 32);
} if (rf & 2) {
    const ctx_r129 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("hide", !(ctx_r129.dataSource == null ? null : ctx_r129.dataSource.loading));
} }
const _c3 = [[["", "form-fields-start", ""]], [["", "form-fields-end", ""]], [["", "pre-content", ""]], "*"];
const _c4 = function () { return ["noresults"]; };
const _c5 = function () { return ["loading"]; };
const _c6 = function () { return [10, 25, 50, 75, 100]; };
const _c7 = ["[form-fields-start]", "[form-fields-end]", "[pre-content]", "*"];
function ListViewComponent_mat_list_0_ng_container_1_ng_template_1_Template(rf, ctx) { }
const _c8 = function (a0) { return { item: a0 }; };
function ListViewComponent_mat_list_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ListViewComponent_mat_list_0_ng_container_1_ng_template_1_Template, 0, 0, "ng-template", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r147 = ctx.$implicit;
    const ctx_r143 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r143.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c1, ɵngcc0.ɵɵpureFunction1(2, _c8, item_r147)));
} }
function ListViewComponent_mat_list_0_mat_list_item_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-list-item", 7);
    ɵngcc0.ɵɵelementStart(1, "p", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r144 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r144.config.labels.noResults);
} }
function ListViewComponent_mat_list_0_mat_list_item_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-list-item", 9);
    ɵngcc0.ɵɵelement(1, "mat-spinner", 10);
    ɵngcc0.ɵɵelementEnd();
} }
function ListViewComponent_mat_list_0_mat_list_item_4_Template(rf, ctx) { if (rf & 1) {
    const _r151 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-list-item", 11);
    ɵngcc0.ɵɵelementStart(1, "button", 12);
    ɵngcc0.ɵɵlistener("click", function ListViewComponent_mat_list_0_mat_list_item_4_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r151); const ctx_r150 = ɵngcc0.ɵɵnextContext(2); return ctx_r150.nextPage(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r146 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r146.dataSource == null ? null : ctx_r146.dataSource.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r146.config.actions.showMore.label, " ");
} }
function ListViewComponent_mat_list_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-list", 1);
    ɵngcc0.ɵɵtemplate(1, ListViewComponent_mat_list_0_ng_container_1_Template, 2, 6, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, ListViewComponent_mat_list_0_mat_list_item_2_Template, 3, 1, "mat-list-item", 3);
    ɵngcc0.ɵɵtemplate(3, ListViewComponent_mat_list_0_mat_list_item_3_Template, 2, 0, "mat-list-item", 4);
    ɵngcc0.ɵɵtemplate(4, ListViewComponent_mat_list_0_mat_list_item_4_Template, 3, 2, "mat-list-item", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const items_r142 = ctx.ngIf;
    const ctx_r141 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", items_r142)("ngForTrackBy", ctx_r141.dataSource == null ? null : ctx_r141.dataSource.trackByFn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r141.dataSource == null ? null : ctx_r141.dataSource.loading) && items_r142.length < 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r141.dataSource == null ? null : ctx_r141.dataSource.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", items_r142.length > 0 && items_r142.length < (ctx_r141.dataSource == null ? null : ctx_r141.dataSource.maxCount));
} }
function ColumnSelectionComponent_mat_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const name_r154 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", name_r154);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(name_r154);
} }
const ANT_UI_CONFIG = new InjectionToken('ant-ui.config');
const DEFAULT_ANT_UI_CONFIG = {
    labels: {
        noResults: 'No results',
        selectColumn: 'Select',
        displayedColumns: 'Displayed Columns',
    },
    actions: {
        showMore: {
            label: 'Show more',
            icon: '',
        },
        showLess: {
            label: 'Show less',
            icon: '',
        },
        filter: {
            label: 'Filter',
            icon: '',
        }
    }
};

const ANT_UI_DEFAULT_BUTTON_CONFIG = new InjectionToken('ant_ui.default_button_config');

class BaseDataSource extends DataSource {
    constructor(dataProvider, defaultOptions) {
        super();
        this.dataProvider = dataProvider;
        this.defaultOptions = defaultOptions;
        this.connectedCount = 0;
        this.load$ = new Subject();
        this.items$ = new BehaviorSubject([]);
        this.loading$ = new BehaviorSubject(false);
        this.loadingSubscription = Subscription.EMPTY;
        this.trackByFn = (idx, value) => value;
        this.loadingParams = defaultOptions || {};
        this.initializeLoading();
    }
    connect(collectionViewer) {
        this.connectedCount++;
        if (this.connectedCount === 1) {
            this.startLoading();
        }
        return this.items$.asObservable();
    }
    disconnect(collectionViewer) {
        this.connectedCount--;
        if (this.connectedCount <= 0) {
            this.loadingSubscription.unsubscribe();
            this.items$.complete();
            this.loading$.complete();
        }
    }
    get items() {
        return this.items$.getValue();
    }
    get loading() {
        return this.loading$.value;
    }
    reload() {
        this.startLoading(true);
    }
    getLoadingParams() {
        return this.loadingParams;
    }
    initializeLoading() {
        this.loadingSubscription.unsubscribe();
        this.loadingSubscription = this.getLoadingSubject().pipe(switchMap(() => this.loadItems())).subscribe(x => this.handleResponse(x));
    }
    getLoadingSubject() {
        return this.load$.asObservable();
    }
    loadItems() {
        this.loading$.next(true);
        return this.dataProvider.getData(this.getLoadingParams());
    }
    handleResponse(res) {
        this.loading$.next(false);
        this.items$.next(res.data);
    }
    startLoading(reload = false) {
        this.load$.next(reload);
    }
}

class AntDataSource extends BaseDataSource {
    constructor(dataProvider, defaultOptions) {
        super(dataProvider, Object.assign({ pageIndex: 0, pageSize: 25, maxCount: null }, defaultOptions));
    }
    get pageSize() {
        return this.loadingParams.pageSize;
    }
    set pageSize(v) {
        if (this.loadingParams.pageSize !== v) {
            this.loadingParams.pageSize = v;
            this.pageIndex = 0;
        }
    }
    get pageIndex() {
        return this.loadingParams.pageIndex;
    }
    set pageIndex(v) {
        this.loadingParams.pageIndex = v;
        this.load$.next();
    }
    get maxCount() {
        return this.loadingParams.maxCount;
    }
    set maxCount(v) {
        this.loadingParams.maxCount = v;
    }
    getLoadingSubject() {
        return super.getLoadingSubject().pipe(debounceTime(100), filter((reload) => reload || (this.pageIndex * this.pageSize) <= this.maxCount));
    }
    handleResponse(res) {
        this.maxCount = res.maxCount;
        super.handleResponse(res);
    }
}

class AntFilterDataSource extends AntDataSource {
    constructor(dataProvider, defaultOptions) {
        super(dataProvider, Object.assign({ filterName: null, filterValue: null }, defaultOptions));
    }
    get filterName() {
        return this.loadingParams.filterName;
    }
    set filterName(v) {
        this.loadingParams.filterName = v;
        this.pageIndex = 0;
    }
    get filterValue() {
        return this.loadingParams.filterValue;
    }
    set filterValue(v) {
        this.loadingParams.filterValue = v;
        this.pageIndex = 0;
    }
}

class AntSortDataSource extends AntFilterDataSource {
    constructor(dataProvider, defaultOptions) {
        super(dataProvider, Object.assign({ sortName: null, sortDir: null }, defaultOptions));
    }
    get sortName() {
        return this.loadingParams.sortName;
    }
    set sortName(v) {
        if (this.loadingParams.sortName !== v) {
            this.loadingParams.sortDir = 'asc';
        }
        this.loadingParams.sortName = v;
        this.pageIndex = 0;
    }
    get sortDir() {
        return this.loadingParams.sortDir;
    }
    set sortDir(v) {
        this.loadingParams.sortDir = v;
        this.pageIndex = 0;
    }
}

let GridTemplateDirective = class GridTemplateDirective {
    constructor(template) {
        this.template = template;
    }
};
GridTemplateDirective.ɵfac = function GridTemplateDirective_Factory(t) { return new (t || GridTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
GridTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: GridTemplateDirective, selectors: [["", "antGridTemplate", ""]], inputs: { key: "key" } });
GridTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
__decorate([
    Input()
], GridTemplateDirective.prototype, "key", void 0);

let GridViewComponent = class GridViewComponent {
    constructor() {
        this.gridTiles = [];
        this.gridTemplateMap = {};
    }
    ngAfterContentInit() {
        // store queried templates in map for use in template
        this.gridTemplates.forEach(t => this.gridTemplateMap[t.key] = t.template);
    }
    getColspanClasses(tile) {
        if (!tile.configurations) {
            return '';
        }
        const classes = [];
        if (tile.configurations.sm) {
            classes.push('mdc-layout-grid__cell--span-' + tile.configurations.sm.colSpan);
        }
        if (tile.configurations.md) {
            classes.push('mdc-layout-grid__cell--span-' + tile.configurations.md.colSpan + '-tablet');
        }
        if (tile.configurations.lg) {
            classes.push('mdc-layout-grid__cell--span-' + tile.configurations.lg.colSpan + '-desktop');
        }
        return classes.join(' ');
    }
};
GridViewComponent.ɵfac = function GridViewComponent_Factory(t) { return new (t || GridViewComponent)(); };
GridViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GridViewComponent, selectors: [["ant-grid-view"]], contentQueries: function GridViewComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, GridTemplateDirective, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gridTemplates = _t);
    } }, inputs: { gridTiles: "gridTiles" }, decls: 3, vars: 1, consts: [[1, "mdc-layout-grid"], [1, "mdc-layout-grid__inner"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "mdc-layout-grid__cell", 3, "classList", "ngClass"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function GridViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, GridViewComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.gridTiles);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet], styles: [".mdc-layout-grid__cell[_ngcontent-%COMP%]{position:relative}.mdc-layout-grid__cell[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{max-height:inherit;max-width:inherit;overflow:auto}"] });
__decorate([
    Input()
], GridViewComponent.prototype, "gridTiles", void 0);
__decorate([
    ContentChildren(GridTemplateDirective)
], GridViewComponent.prototype, "gridTemplates", void 0);

const DEFAULT_CONFIG = {
    actionName: '',
    disabled: false,
    loading: false,
    type: 'button',
    mode: 'normal',
    hideIcon: false,
    hideLabel: false,
    prefix: '',
    labelSuffix: '',
    iconSuffix: '',
    labelHideBreakpoints: [Breakpoints.XSmall],
    uppercase: true
};
let ButtonComponent = class ButtonComponent {
    constructor(bpo, config) {
        this.bpo = bpo;
        this.config = config;
        this.config = Object.assign(Object.assign({}, DEFAULT_CONFIG), this.config);
    }
    ngOnInit() {
        this.actionName = this.actionName || this.config.actionName;
        this.loading = this.loading || this.config.loading;
        this.disabled = this.disabled || this.config.disabled;
        this.color = this.color || this.config.color;
        this.type = this.type || this.config.type;
        this.mode = this.mode || this.config.mode;
        this.hideIcon = this.hideIcon || this.config.hideIcon;
        this.hideLabel = this.hideLabel || this.config.hideLabel;
        this.prefix = this.prefix || this.config.prefix;
        this.iconSuffix = this.iconSuffix || this.config.iconSuffix;
        this.labelSuffix = this.labelSuffix || this.config.labelSuffix;
        this.labelHideBreakpoints = this.labelHideBreakpoints || this.config.labelHideBreakpoints;
        this.uppercase = this.uppercase || this.config.uppercase;
        this.isMobile$ = this.bpo.observe(this.labelHideBreakpoints || this.config.labelHideBreakpoints).pipe(map(res => res.matches || this.hideLabel));
    }
    onClick(event) {
        if (this.disabled || this.loading) {
            event.stopPropagation();
            event.preventDefault();
            return event.returnValue = false;
        }
    }
};
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.BreakpointObserver), ɵngcc0.ɵɵdirectiveInject(ANT_UI_DEFAULT_BUTTON_CONFIG, 8)); };
ButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["ant-button"]], inputs: { actionName: "actionName", loading: "loading", disabled: "disabled", color: "color", type: "type", mode: "mode", hideIcon: "hideIcon", hideLabel: "hideLabel", prefix: "prefix", iconSuffix: "iconSuffix", labelSuffix: "labelSuffix", labelHideBreakpoints: "labelHideBreakpoints", uppercase: "uppercase" }, decls: 9, vars: 5, consts: [[1, "ant-button", 3, "click"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["mobile", ""], ["normal", ""], ["inner", ""], ["mat-icon-button", "", 1, "icon-only", 3, "type", "disabled", "color"], [4, "ngTemplateOutlet"], [3, "ngSwitch"], ["mat-stroked-button", "", 3, "type", "disabled", "color", "label-only", 4, "ngSwitchCase"], ["mat-raised-button", "", 3, "type", "disabled", "color", "label-only", 4, "ngSwitchCase"], ["mat-flat-button", "", 3, "type", "disabled", "color", "label-only", 4, "ngSwitchCase"], ["mat-button", "", 3, "type", "disabled", "color", "label-only", 4, "ngSwitchDefault"], ["mat-stroked-button", "", 3, "type", "disabled", "color"], ["mat-raised-button", "", 3, "type", "disabled", "color"], ["mat-flat-button", "", 3, "type", "disabled", "color"], ["mat-button", "", 3, "type", "disabled", "color"], ["class", "icon", 4, "ngIf"], [1, "label"], ["class", "loading-wrapper", 4, "ngIf"], [1, "icon"], [1, "loading-wrapper"], ["diameter", "16", "strokeWidth", "2", 3, "color"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function ButtonComponent_Template_div_click_0_listener($event) { return ctx.onClick($event); });
        ɵngcc0.ɵɵtemplate(1, ButtonComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵtemplate(3, ButtonComponent_ng_template_3_Template, 2, 4, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, ButtonComponent_ng_template_5_Template, 5, 4, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, ButtonComponent_ng_template_7_Template, 5, 7, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r103 = ɵngcc0.ɵɵreference(4);
        const _r105 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 3, ctx.isMobile$) || ctx.mode === "icon")("ngIfThen", _r103)("ngIfElse", _r105);
    } }, directives: [ɵngcc1.NgIf, ɵngcc3.MatButton, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, ɵngcc4.MatIcon, ɵngcc5.MatSpinner], pipes: [ɵngcc1.AsyncPipe, ɵngcc6.TranslatePipe], styles: ["button[_ngcontent-%COMP%]{position:relative}button[_ngcontent-%COMP%]:not([mat-icon-button]){height:2.25rem;min-width:4rem;padding:0 .75rem;box-sizing:border-box}button[_ngcontent-%COMP%]:not([mat-icon-button])   .icon[_ngcontent-%COMP%]{height:1.125rem;width:1.125rem;font-size:1.125rem;margin-right:.25rem}button[_ngcontent-%COMP%]:not([mat-icon-button])   .label[_ngcontent-%COMP%]{margin:0 .25rem}button[mat-button][_ngcontent-%COMP%]{padding:0 .25rem}button[mat-button][_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin-left:.25rem}button[_ngcontent-%COMP%]   .loading-wrapper[_ngcontent-%COMP%]{position:absolute;left:0;right:0;top:0;bottom:0;display:flex;flex-flow:column;justify-content:center}button[_ngcontent-%COMP%]   .loading-wrapper[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.icon-only[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%], .label-only[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{display:none}.uppercase[_ngcontent-%COMP%]{text-transform:uppercase}"] });
ButtonComponent.ctorParameters = () => [
    { type: BreakpointObserver },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [ANT_UI_DEFAULT_BUTTON_CONFIG,] }] }
];
__decorate([
    Input()
], ButtonComponent.prototype, "actionName", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "loading", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "color", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "type", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "mode", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "hideIcon", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "hideLabel", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "prefix", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "iconSuffix", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "labelSuffix", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "labelHideBreakpoints", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "uppercase", void 0);
ButtonComponent = __decorate([ __param(1, Optional()), __param(1, Inject(ANT_UI_DEFAULT_BUTTON_CONFIG))
], ButtonComponent);

class MockDataProvider {
    getData(args) {
        return of({
            data: [],
            maxCount: 0
        });
    }
}

let StorageService = class StorageService {
    constructor() {
        this.prefix = 'ant-ui-';
        this.storage = localStorage;
    }
    clear() {
        this.storage.clear();
    }
    hasItem(key) {
        const buildKey = this.buildKey(key);
        return this.storage.getItem(buildKey) !== null;
    }
    getItem(key) {
        const buildKey = this.buildKey(key);
        if (!this.hasItem(key)) {
            return null;
        }
        const jsonString = this.storage.getItem(buildKey);
        return this.tryParseJsonOrReturnNull(jsonString);
    }
    removeItem(key) {
        const buildKey = this.buildKey(key);
        this.storage.removeItem(buildKey);
    }
    setItem(key, value) {
        const buildKey = this.buildKey(key);
        const jsonString = JSON.stringify(value);
        this.storage.setItem(buildKey, jsonString);
    }
    buildKey(key) {
        if (key.startsWith(this.prefix)) {
            return key;
        }
        return this.prefix + key;
    }
    tryParseJsonOrReturnNull(jsonString) {
        try {
            return JSON.parse(jsonString);
        }
        catch (e) {
            return null;
        }
    }
};
StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(); };
StorageService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: StorageService, factory: StorageService.ɵfac });

class ColumnHolder {
    constructor() {
        this.availableColumns = [];
        this.visibleColumns = [];
    }
    isColumnVisible(name) {
        return this.visibleColumns.includes(name);
    }
    isColumnAvailable(name) {
        return this.availableColumns.includes(name);
    }
    getAvailableColumns() {
        return this.availableColumns;
    }
    getVisibleColumns() {
        return this.visibleColumns;
    }
    addColumn(name) {
        if (!name || this.isColumnAvailable(name)) {
            return;
        }
        this.availableColumns.push(name);
    }
    removeColumn(name) {
        if (!name) {
            return;
        }
        this.removeColumnSafelyFrom(name, this.visibleColumns);
        this.removeColumnSafelyFrom(name, this.availableColumns);
    }
    showColumns(names) {
        if (!names) {
            return;
        }
        this.visibleColumns.splice(0, this.visibleColumns.length);
        names.forEach(name => this.showColumn(name));
    }
    showColumn(name) {
        if (!name || this.isColumnVisible(name) || !this.isColumnAvailable(name)) {
            return;
        }
        this.visibleColumns.push(name);
    }
    removeColumnSafelyFrom(column, collection) {
        const idx = collection.indexOf(column);
        if (idx < 0) {
            return;
        }
        collection.splice(idx, 1);
    }
}

let TableViewComponent = class TableViewComponent {
    constructor(config, storage) {
        this.config = config;
        this.storage = storage;
        this.contentColumns = new QueryList();
        this.dataSource = new AntFilterDataSource(new MockDataProvider());
        this.selection = new SelectionModel(true, []);
        this.showFilter = true;
        this.showDisplayedColumns = true;
        this.showSelectionColumn = true;
        this.rowClicked = new EventEmitter();
        this.rowRightClicked = new EventEmitter();
        this.columnHolder = new ColumnHolder();
        this.displayingColumns = [];
    }
    get storageKey() {
        return 'ant-ui-table-view-' + this.id;
    }
    set displayedColumns(value) {
        this.columnHolder.showColumns(value);
    }
    get displayedColumns() {
        return this.displayingColumns;
    }
    ngOnInit() {
        this.displayingColumns = this.columnHolder.getVisibleColumns();
    }
    ngAfterViewInit() {
        this.paginator.page.pipe(debounceTime(150)).subscribe(page => {
            this.dataSource.pageSize = page.pageSize;
            this.dataSource.pageIndex = page.pageIndex;
        });
        this.filter.update.pipe(debounceTime(350)).subscribe(filterValue => {
            this.dataSource.filterValue = filterValue;
        });
    }
    ngAfterContentInit() {
        this.addColumns();
        this.setId();
        this.showColumns();
    }
    ngOnDestroy() {
        this.saveColumns();
    }
    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.items.length;
        return numSelected === numRows;
    }
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.items.forEach(row => this.selection.select(row));
    }
    onShowClick(item) {
        if (!this.selection.selected.length) {
            // only emits if selection is not active
            this.rowClicked.emit(item);
        }
        else {
            // else toggle selection
            this.selection.toggle(item);
        }
    }
    onRightClick(event, item) {
        event.data = item;
        this.rowRightClicked.emit(event);
    }
    setId() {
        if (!this.id) {
            const availableColumns = this.columnHolder.getAvailableColumns();
            const lowerCaseColumns = availableColumns.map(name => name.toLowerCase());
            const normalizedColumns = lowerCaseColumns.map(name => name.normalize('NFC').trim());
            this.id = normalizedColumns.join('');
        }
    }
    addColumns() {
        if (this.showSelectionColumn) {
            this.columnHolder.addColumn(this.config.labels.selectColumn);
        }
        this.contentColumns.forEach(column => {
            if (this.areAvailableColumnsOverridden() && !this.isColumnInOverriddenAvailableColumns(column.name)) {
                return;
            }
            this.table.addColumnDef(column);
            this.columnHolder.addColumn(column.name);
        });
    }
    isColumnInOverriddenAvailableColumns(name) {
        var _a;
        return (_a = this.availableColumns) === null || _a === void 0 ? void 0 : _a.includes(name);
    }
    areAvailableColumnsOverridden() {
        return !!this.availableColumns && this.availableColumns.length > 0;
    }
    hasDefaultVisibleColumns() {
        return !!this.defaultDisplayedColumns && this.defaultDisplayedColumns.length > 0;
    }
    showColumns() {
        if (this.storage.hasItem(this.storageKey)) {
            const colsInStorage = this.storage.getItem(this.storageKey);
            this.columnHolder.showColumns(colsInStorage);
        }
        else if (this.hasDefaultVisibleColumns()) {
            this.columnHolder.showColumns(this.defaultDisplayedColumns);
        }
        else {
            const availableColumns = this.columnHolder.getAvailableColumns();
            this.columnHolder.showColumns(availableColumns);
        }
    }
    saveColumns() {
        this.storage.setItem(this.storageKey, this.displayingColumns);
    }
};
TableViewComponent.ɵfac = function TableViewComponent_Factory(t) { return new (t || TableViewComponent)(ɵngcc0.ɵɵdirectiveInject(ANT_UI_CONFIG), ɵngcc0.ɵɵdirectiveInject(StorageService)); };
TableViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TableViewComponent, selectors: [["ant-table-view"]], contentQueries: function TableViewComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MatColumnDef, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentColumns = _t);
    } }, viewQuery: function TableViewComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(MatTable, true);
        ɵngcc0.ɵɵstaticViewQuery(MatPaginator, true);
        ɵngcc0.ɵɵviewQuery(_c2, true, NgModel);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.table = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filter = _t.first);
    } }, hostBindings: function TableViewComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("unload", function TableViewComponent_unload_HostBindingHandler() { return ctx.ngOnDestroy(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { dataSource: "dataSource", selection: "selection", showFilter: "showFilter", showDisplayedColumns: "showDisplayedColumns", showSelectionColumn: "showSelectionColumn", displayedColumns: "displayedColumns", id: "id", availableColumns: "availableColumns", defaultDisplayedColumns: "defaultDisplayedColumns" }, outputs: { rowClicked: "rowClicked", rowRightClicked: "rowRightClicked" }, ngContentSelectors: _c7, decls: 23, vars: 18, consts: [[1, "ant-table-view"], [1, "form-fields"], [4, "ngIf"], [3, "label", "columnHolder", 4, "ngIf"], [1, "table-wrapper"], ["mat-table", "", 3, "dataSource", "trackBy"], [3, "matColumnDef"], ["mat-header-cell", "", "class", "checkbox-cell", 4, "matHeaderCellDef"], ["mat-cell", "", "class", "checkbox-cell", 4, "matCellDef"], ["matColumnDef", "noresults"], ["mat-footer-cell", "", 3, "colSpan", 4, "matFooterCellDef"], ["matColumnDef", "loading"], ["mat-header-row", "", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], ["mat-row", "", 3, "click", "contextmenu", 4, "matRowDef", "matRowDefColumns"], ["mat-footer-row", "", 3, "hide", 4, "matFooterRowDef"], [1, "footer"], [3, "pageSizeOptions", "length", "pageSize", "pageIndex", "disabled"], ["matSuffix", ""], ["matInput", "", 3, "ngModel"], ["filter", ""], [3, "label", "columnHolder"], ["mat-header-cell", "", 1, "checkbox-cell"], [1, "checkbox-wrapper"], [3, "checked", "indeterminate", "change"], ["mat-cell", "", 1, "checkbox-cell"], [3, "checked", "click", "change"], ["mat-footer-cell", "", 3, "colSpan"], [1, "no-results"], [1, "loading"], ["diameter", "32"], ["mat-header-row", ""], ["mat-row", "", 3, "click", "contextmenu"], ["mat-footer-row", ""]], template: function TableViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵtemplate(3, TableViewComponent_mat_form_field_3_Template, 7, 3, "mat-form-field", 2);
        ɵngcc0.ɵɵtemplate(4, TableViewComponent_ant_column_selection_4_Template, 1, 2, "ant-column-selection", 3);
        ɵngcc0.ɵɵprojection(5, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(6, 2);
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "table", 5);
        ɵngcc0.ɵɵelementContainerStart(9, 6);
        ɵngcc0.ɵɵtemplate(10, TableViewComponent_th_10_Template, 3, 2, "th", 7);
        ɵngcc0.ɵɵtemplate(11, TableViewComponent_td_11_Template, 3, 1, "td", 8);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵprojection(12, 3);
        ɵngcc0.ɵɵelementContainerStart(13, 9);
        ɵngcc0.ɵɵtemplate(14, TableViewComponent_td_14_Template, 3, 2, "td", 10);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementContainerStart(15, 11);
        ɵngcc0.ɵɵtemplate(16, TableViewComponent_td_16_Template, 3, 1, "td", 10);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵtemplate(17, TableViewComponent_tr_17_Template, 1, 0, "tr", 12);
        ɵngcc0.ɵɵtemplate(18, TableViewComponent_tr_18_Template, 1, 0, "tr", 13);
        ɵngcc0.ɵɵtemplate(19, TableViewComponent_tr_19_Template, 1, 2, "tr", 14);
        ɵngcc0.ɵɵtemplate(20, TableViewComponent_tr_20_Template, 1, 2, "tr", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 15);
        ɵngcc0.ɵɵelement(22, "mat-paginator", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFilter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDisplayedColumns);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("dataSource", ctx.dataSource)("trackBy", ctx.dataSource == null ? null : ctx.dataSource.trackByFn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("matColumnDef", ctx.config.labels.selectColumn);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("matHeaderRowDef", ctx.displayingColumns)("matHeaderRowDefSticky", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("matRowDefColumns", ctx.displayingColumns);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("matFooterRowDef", ɵngcc0.ɵɵpureFunction0(15, _c4));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("matFooterRowDef", ɵngcc0.ɵɵpureFunction0(16, _c5));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("pageSizeOptions", ɵngcc0.ɵɵpureFunction0(17, _c6))("length", ctx.dataSource == null ? null : ctx.dataSource.maxCount)("pageSize", ctx.dataSource == null ? null : ctx.dataSource.pageSize)("pageIndex", ctx.dataSource == null ? null : ctx.dataSource.pageIndex)("disabled", ctx.dataSource == null ? null : ctx.dataSource.loading);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc7.MatTable, ɵngcc7.MatColumnDef, ɵngcc7.MatHeaderCellDef, ɵngcc7.MatCellDef, ɵngcc7.MatFooterCellDef, ɵngcc7.MatHeaderRowDef, ɵngcc7.MatRowDef, ɵngcc7.MatFooterRowDef, ɵngcc8.MatPaginator, ɵngcc9.MatFormField, ɵngcc9.MatLabel, ɵngcc4.MatIcon, ɵngcc9.MatSuffix, ɵngcc10.MatInput, ɵngcc11.DefaultValueAccessor, ɵngcc11.NgControlStatus, ɵngcc11.NgModel, ColumnSelectionComponent, ɵngcc7.MatHeaderCell, ɵngcc12.MatCheckbox, ɵngcc7.MatCell, ɵngcc7.MatFooterCell, ɵngcc9.MatHint, ɵngcc5.MatSpinner, ɵngcc7.MatHeaderRow, ɵngcc7.MatRow, ɵngcc7.MatFooterRow]; }, styles: [".ant-table-view[_ngcontent-%COMP%]{height:100%;width:100%;max-height:100%;max-width:100%;display:flex;flex-flow:column nowrap}.ant-table-view[_ngcontent-%COMP%]   .form-fields[_ngcontent-%COMP%]{display:flex;flex-flow:row wrap}.ant-table-view[_ngcontent-%COMP%]   .form-fields[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:1 auto;min-width:8rem;box-sizing:border-box;overflow:hidden}.ant-table-view[_ngcontent-%COMP%]   .table-wrapper[_ngcontent-%COMP%]{flex:1 auto;overflow:auto;position:relative}.hide[_ngcontent-%COMP%]{display:none}.form-fields[_ngcontent-%COMP%]{display:flex;width:100%;justify-items:center;padding:.5rem;box-sizing:border-box}.form-fields[_ngcontent-%COMP%] > mat-form-field[_ngcontent-%COMP%]{margin:0 .5rem;flex:1 auto}table[_ngcontent-%COMP%]{width:100%}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{cursor:pointer}table[_ngcontent-%COMP%]   .checkbox-cell[_ngcontent-%COMP%]{width:1rem;padding-left:1rem;padding-right:1rem}table[_ngcontent-%COMP%]   .checkbox-cell[_ngcontent-%COMP%]   .checkbox-wrapper[_ngcontent-%COMP%]{display:flex;align-content:center}table[_ngcontent-%COMP%]   .checkbox-cell[_ngcontent-%COMP%]   .checkbox-wrapper[_ngcontent-%COMP%]   mat-checkbox[_ngcontent-%COMP%]{display:inline-flex;margin:1px}table[_ngcontent-%COMP%]   .no-results[_ngcontent-%COMP%]{width:100%;text-align:center}table[_ngcontent-%COMP%]   .loading[_ngcontent-%COMP%]{display:flex;justify-content:center;padding:.5rem}"] });
TableViewComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ANT_UI_CONFIG,] }] },
    { type: StorageService }
];
__decorate([
    ViewChild(MatTable, { static: true })
], TableViewComponent.prototype, "table", void 0);
__decorate([
    ViewChild(MatPaginator, { static: true })
], TableViewComponent.prototype, "paginator", void 0);
__decorate([
    ViewChild('filter', { read: NgModel })
], TableViewComponent.prototype, "filter", void 0);
__decorate([
    ContentChildren(MatColumnDef)
], TableViewComponent.prototype, "contentColumns", void 0);
__decorate([
    Input()
], TableViewComponent.prototype, "id", void 0);
__decorate([
    Input()
], TableViewComponent.prototype, "dataSource", void 0);
__decorate([
    Input()
], TableViewComponent.prototype, "selection", void 0);
__decorate([
    Input()
], TableViewComponent.prototype, "showFilter", void 0);
__decorate([
    Input()
], TableViewComponent.prototype, "showDisplayedColumns", void 0);
__decorate([
    Input()
], TableViewComponent.prototype, "showSelectionColumn", void 0);
__decorate([
    Input()
], TableViewComponent.prototype, "availableColumns", void 0);
__decorate([
    Input()
], TableViewComponent.prototype, "defaultDisplayedColumns", void 0);
__decorate([
    Output()
], TableViewComponent.prototype, "rowClicked", void 0);
__decorate([
    Output()
], TableViewComponent.prototype, "rowRightClicked", void 0);
__decorate([
    Input()
], TableViewComponent.prototype, "displayedColumns", null);
__decorate([
    HostListener('window:unload')
], TableViewComponent.prototype, "ngOnDestroy", null);
TableViewComponent = __decorate([ __param(0, Inject(ANT_UI_CONFIG))
], TableViewComponent);

let ListViewComponent = class ListViewComponent {
    constructor(config) {
        this.config = config;
        this.dataSource = new AntDataSource(new MockDataProvider());
    }
    ngOnInit() {
        this.items$ = this.dataSource.connect(null).pipe(scan((prev, next) => {
            if (this.dataSource.pageIndex > 0) {
                return [
                    ...prev,
                    ...next.filter(x => !prev.includes(x))
                ];
            }
            return next;
        }, []));
    }
    nextPage() {
        this.dataSource.pageIndex++;
    }
};
ListViewComponent.ɵfac = function ListViewComponent_Factory(t) { return new (t || ListViewComponent)(ɵngcc0.ɵɵdirectiveInject(ANT_UI_CONFIG)); };
ListViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ListViewComponent, selectors: [["ant-list-view"]], contentQueries: function ListViewComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, inputs: { dataSource: "dataSource" }, decls: 2, vars: 3, consts: [["class", "ant-list-view", 4, "ngIf"], [1, "ant-list-view"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "no-results", 4, "ngIf"], ["class", "loading", 4, "ngIf"], ["class", "load-more", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "no-results"], ["mat-line", ""], [1, "loading"], ["diameter", "24"], [1, "load-more"], ["mat-button", "", 3, "disabled", "click"]], template: function ListViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ListViewComponent_mat_list_0_Template, 5, 5, "mat-list", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.items$));
    } }, directives: [ɵngcc1.NgIf, ɵngcc13.MatList, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet, ɵngcc13.MatListItem, ɵngcc14.MatLine, ɵngcc5.MatSpinner, ɵngcc3.MatButton], pipes: [ɵngcc1.AsyncPipe], styles: [".ant-list-view[_ngcontent-%COMP%]{width:100%;max-width:100%;height:100%;max-height:100%;overflow:auto}.ant-list-view[_ngcontent-%COMP%]   .loading[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:center}.ant-list-view[_ngcontent-%COMP%]   .load-more[_ngcontent-%COMP%], .ant-list-view[_ngcontent-%COMP%]   .load-more[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:100%}.ant-list-view[_ngcontent-%COMP%]   .no-results[_ngcontent-%COMP%]{width:100%;text-align:center}"] });
ListViewComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ANT_UI_CONFIG,] }] }
];
__decorate([
    ContentChild(TemplateRef)
], ListViewComponent.prototype, "templateRef", void 0);
__decorate([
    Input()
], ListViewComponent.prototype, "dataSource", void 0);
ListViewComponent = __decorate([ __param(0, Inject(ANT_UI_CONFIG))
], ListViewComponent);

const modules = [
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatLineModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule
];
let MaterialModule = class MaterialModule {
};
MaterialModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MaterialModule });
MaterialModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MaterialModule_Factory(t) { return new (t || MaterialModule)(); }, imports: [modules,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDividerModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatLineModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSortModule,
        MatTableModule] });

let ColumnSelectionComponent = class ColumnSelectionComponent {
    constructor() {
        this.availableColumns = [];
        this.visibleColumns = [];
    }
    ngOnInit() {
        this.availableColumns = this.columnHolder.getAvailableColumns();
        this.visibleColumns = this.columnHolder.getVisibleColumns();
    }
    onSelectionChange(columns) {
        this.columnHolder.showColumns(columns);
    }
};
ColumnSelectionComponent.ɵfac = function ColumnSelectionComponent_Factory(t) { return new (t || ColumnSelectionComponent)(); };
ColumnSelectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ColumnSelectionComponent, selectors: [["ant-column-selection"]], inputs: { label: "label", columnHolder: "columnHolder" }, decls: 6, vars: 3, consts: [["multiple", "", 3, "ngModel", "ngModelChange"], ["select", ""], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function ColumnSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field");
        ɵngcc0.ɵɵelementStart(1, "mat-label");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "mat-select", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function ColumnSelectionComponent_Template_mat_select_ngModelChange_3_listener($event) { return ctx.onSelectionChange($event); });
        ɵngcc0.ɵɵtemplate(5, ColumnSelectionComponent_mat_option_5_Template, 2, 2, "mat-option", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.visibleColumns);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.availableColumns);
    } }, directives: [ɵngcc9.MatFormField, ɵngcc9.MatLabel, ɵngcc15.MatSelect, ɵngcc11.NgControlStatus, ɵngcc11.NgModel, ɵngcc1.NgForOf, ɵngcc14.MatOption], styles: ["mat-form-field[_ngcontent-%COMP%]{width:100%;box-sizing:border-box;overflow:hidden}"] });
__decorate([
    Input()
], ColumnSelectionComponent.prototype, "label", void 0);
__decorate([
    Input()
], ColumnSelectionComponent.prototype, "columnHolder", void 0);

const ɵ0 = DEFAULT_ANT_UI_CONFIG;
let AntUiModule = class AntUiModule {
};
AntUiModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AntUiModule });
AntUiModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AntUiModule_Factory(t) { return new (t || AntUiModule)(); }, providers: [
        { provide: ANT_UI_CONFIG, useValue: ɵ0 },
        StorageService
    ], imports: [[
            CommonModule,
            FormsModule,
            TranslateModule.forChild(),
            MaterialModule
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GridTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[antGridTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, { key: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GridViewComponent, [{
        type: Component,
        args: [{
                selector: 'ant-grid-view',
                template: "<div class=\"mdc-layout-grid\">\n  <div class=\"mdc-layout-grid__inner\">\n    <ng-container *ngFor=\"let tile of gridTiles\">\n      <ng-container *ngIf=\"tile && gridTemplateMap[tile?.templateKey]\">\n        <div class=\"mdc-layout-grid__cell\"\n             [classList]=\"tile.classes || ''\"\n             [ngClass]=\"getColspanClasses(tile)\"\n        >\n          <ng-container [ngTemplateOutlet]=\"gridTemplateMap[tile.templateKey]\" [ngTemplateOutletContext]=\"{$implicit: {data: tile.data}}\"></ng-container>\n        </div>\n      </ng-container>\n    </ng-container>\n  </div>\n</div>\n",
                styles: [".mdc-layout-grid__cell{position:relative}.mdc-layout-grid__cell>*{max-height:inherit;max-width:inherit;overflow:auto}"]
            }]
    }], function () { return []; }, { gridTiles: [{
            type: Input
        }], gridTemplates: [{
            type: ContentChildren,
            args: [GridTemplateDirective]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ant-button',
                template: "<div class=\"ant-button\" (click)=\"onClick($event)\">\n  <ng-container *ngIf=\"(isMobile$ | async) || mode === 'icon'; then mobile; else normal\"></ng-container>\n  <ng-template #mobile>\n    <button mat-icon-button\n            [type]=\"type\"\n            [disabled]=\"disabled || loading\"\n            [color]=\"color\"\n            class=\"icon-only\"\n    >\n      <ng-container *ngTemplateOutlet=\"inner\"></ng-container>\n    </button>\n  </ng-template>\n  <ng-template #normal>\n    <ng-container [ngSwitch]=\"mode\">\n      <button *ngSwitchCase=\"'stroked'\" mat-stroked-button\n              [type]=\"type\"\n              [disabled]=\"disabled || loading\"\n              [color]=\"color\"\n              [class.label-only]=\"hideIcon\"\n      >\n        <ng-container *ngTemplateOutlet=\"inner\"></ng-container>\n      </button>\n      <button *ngSwitchCase=\"'raised'\" mat-raised-button\n              [type]=\"type\"\n              [disabled]=\"disabled || loading\"\n              [color]=\"color\"\n              [class.label-only]=\"hideIcon\"\n      >\n        <ng-container *ngTemplateOutlet=\"inner\"></ng-container>\n      </button>\n      <button *ngSwitchCase=\"'flat'\" mat-flat-button\n              [type]=\"type\"\n              [disabled]=\"disabled || loading\"\n              [color]=\"color\"\n              [class.label-only]=\"hideIcon\"\n      >\n        <ng-container *ngTemplateOutlet=\"inner\"></ng-container>\n      </button>\n      <button *ngSwitchDefault mat-button\n              [type]=\"type\"\n              [disabled]=\"disabled || loading\"\n              [color]=\"color\"\n              [class.label-only]=\"hideIcon\"\n      >\n        <ng-container *ngTemplateOutlet=\"inner\"></ng-container>\n      </button>\n    </ng-container>\n  </ng-template>\n\n  <ng-template #inner>\n    <mat-icon class=\"icon\" *ngIf=\"!hideIcon\">{{ (prefix + actionName + iconSuffix) | translate }}</mat-icon>\n    <span class=\"label\" [class.uppercase]=\"uppercase\">{{ (prefix + actionName + labelSuffix) | translate }}</span>\n    <span class=\"loading-wrapper\" *ngIf=\"loading\" >\n    <mat-spinner diameter=\"16\" strokeWidth=\"2\" [color]=\"color\"></mat-spinner>\n  </span>\n  </ng-template>\n</div>\n",
                styles: ["button{position:relative}button:not([mat-icon-button]){height:2.25rem;min-width:4rem;padding:0 .75rem;box-sizing:border-box}button:not([mat-icon-button]) .icon{height:1.125rem;width:1.125rem;font-size:1.125rem;margin-right:.25rem}button:not([mat-icon-button]) .label{margin:0 .25rem}button[mat-button]{padding:0 .25rem}button[mat-button] .icon{margin-left:.25rem}button .loading-wrapper{position:absolute;left:0;right:0;top:0;bottom:0;display:flex;flex-flow:column;justify-content:center}button .loading-wrapper mat-spinner{margin-left:auto;margin-right:auto}.icon-only .label,.label-only .icon{display:none}.uppercase{text-transform:uppercase}"]
            }]
    }], function () { return [{ type: ɵngcc2.BreakpointObserver }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [ANT_UI_DEFAULT_BUTTON_CONFIG]
            }] }]; }, { actionName: [{
            type: Input
        }], loading: [{
            type: Input
        }], disabled: [{
            type: Input
        }], color: [{
            type: Input
        }], type: [{
            type: Input
        }], mode: [{
            type: Input
        }], hideIcon: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], prefix: [{
            type: Input
        }], iconSuffix: [{
            type: Input
        }], labelSuffix: [{
            type: Input
        }], labelHideBreakpoints: [{
            type: Input
        }], uppercase: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StorageService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TableViewComponent, [{
        type: Component,
        args: [{
                selector: 'ant-table-view',
                template: "<div class=\"ant-table-view\">\n  <div class=\"form-fields\">\n    <ng-content select=\"[form-fields-start]\"></ng-content>\n    <mat-form-field *ngIf=\"showFilter\">\n      <mat-label>{{ config.actions.filter.label }}</mat-label>\n      <mat-icon matSuffix>{{ config.actions.filter.icon }}</mat-icon>\n      <input matInput [ngModel]=\"dataSource.filterValue\" #filter>\n    </mat-form-field>\n    <ant-column-selection *ngIf=\"showDisplayedColumns\"\n                          [label]=\"config.labels.displayedColumns\"\n                          [columnHolder]=\"columnHolder\"\n    ></ant-column-selection>\n    <ng-content select=\"[form-fields-end]\"></ng-content>\n  </div>\n  <ng-content select=\"[pre-content]\"></ng-content>\n  <div class=\"table-wrapper\">\n    <table mat-table [dataSource]=\"dataSource\" [trackBy]=\"dataSource?.trackByFn\">\n      <ng-container matColumnDef=\"{{ config.labels.selectColumn }}\">\n        <th mat-header-cell class=\"checkbox-cell\" *matHeaderCellDef>\n          <div class=\"checkbox-wrapper\">\n            <mat-checkbox (change)=\"$event ? masterToggle() : null\"\n                          [checked]=\"selection.hasValue() && isAllSelected()\"\n                          [indeterminate]=\"selection.hasValue() && !isAllSelected()\">\n            </mat-checkbox>\n          </div>\n        </th>\n        <td mat-cell class=\"checkbox-cell\" *matCellDef=\"let row\">\n          <div class=\"checkbox-wrapper\">\n            <mat-checkbox (click)=\"$event.stopPropagation()\"\n                          (change)=\"$event ? selection.toggle(row) : null\"\n                          [checked]=\"selection.isSelected(row)\">\n            </mat-checkbox>\n          </div>\n        </td>\n      </ng-container>\n\n      <ng-content></ng-content>\n\n      <ng-container matColumnDef=\"noresults\">\n        <td mat-footer-cell *matFooterCellDef [colSpan]=\"displayingColumns.length\">\n          <mat-hint class=\"no-results\">{{ config.labels.noResults }}</mat-hint>\n        </td>\n      </ng-container>\n      <ng-container matColumnDef=\"loading\">\n        <td mat-footer-cell *matFooterCellDef [colSpan]=\"displayingColumns.length\">\n          <div class=\"loading\">\n            <mat-spinner diameter=\"32\"></mat-spinner>\n          </div>\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"displayingColumns; sticky: true\"></tr>\n      <tr mat-row *matRowDef=\"let item; columns: displayingColumns;\" (click)=\"onShowClick(item)\" (contextmenu)=\"onRightClick($event, item)\"></tr>\n      <tr mat-footer-row *matFooterRowDef=\"['noresults']\" [class.hide]=\"dataSource?.maxCount > 0\"></tr>\n      <tr mat-footer-row *matFooterRowDef=\"['loading']\" [class.hide]=\"!dataSource?.loading\"></tr>\n    </table>\n  </div>\n  <div class=\"footer\">\n    <mat-paginator [pageSizeOptions]=\"[10, 25, 50, 75, 100]\"\n                   [length]=\"dataSource?.maxCount\"\n                   [pageSize]=\"dataSource?.pageSize\"\n                   [pageIndex]=\"dataSource?.pageIndex\"\n                   [disabled]=\"dataSource?.loading\"\n    ></mat-paginator>\n  </div>\n</div>\n",
                styles: [".ant-table-view{height:100%;width:100%;max-height:100%;max-width:100%;display:flex;flex-flow:column nowrap}.ant-table-view .form-fields{display:flex;flex-flow:row wrap}.ant-table-view .form-fields>*{flex:1 auto;min-width:8rem;box-sizing:border-box;overflow:hidden}.ant-table-view .table-wrapper{flex:1 auto;overflow:auto;position:relative}.hide{display:none}.form-fields{display:flex;width:100%;justify-items:center;padding:.5rem;box-sizing:border-box}.form-fields>mat-form-field{margin:0 .5rem;flex:1 auto}table{width:100%}table tr{cursor:pointer}table .checkbox-cell{width:1rem;padding-left:1rem;padding-right:1rem}table .checkbox-cell .checkbox-wrapper{display:flex;align-content:center}table .checkbox-cell .checkbox-wrapper mat-checkbox{display:inline-flex;margin:1px}table .no-results{width:100%;text-align:center}table .loading{display:flex;justify-content:center;padding:.5rem}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ANT_UI_CONFIG]
            }] }, { type: StorageService }]; }, { contentColumns: [{
            type: ContentChildren,
            args: [MatColumnDef]
        }], dataSource: [{
            type: Input
        }], selection: [{
            type: Input
        }], showFilter: [{
            type: Input
        }], showDisplayedColumns: [{
            type: Input
        }], showSelectionColumn: [{
            type: Input
        }], rowClicked: [{
            type: Output
        }], rowRightClicked: [{
            type: Output
        }], displayedColumns: [{
            type: Input
        }], ngOnDestroy: [{
            type: HostListener,
            args: ['window:unload']
        }], id: [{
            type: Input
        }], table: [{
            type: ViewChild,
            args: [MatTable, { static: true }]
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator, { static: true }]
        }], filter: [{
            type: ViewChild,
            args: ['filter', { read: NgModel }]
        }], availableColumns: [{
            type: Input
        }], defaultDisplayedColumns: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListViewComponent, [{
        type: Component,
        args: [{
                selector: 'ant-list-view',
                template: "<mat-list class=\"ant-list-view\" *ngIf=\"items$ | async as items\">\n  <ng-container *ngFor=\"let item of items; let i = index; trackBy: dataSource?.trackByFn\">\n    <ng-template [ngTemplateOutlet]=\"templateRef\" [ngTemplateOutletContext]=\"{$implicit: {item: item}}\"></ng-template>\n  </ng-container>\n  <mat-list-item class=\"no-results\" *ngIf=\"!dataSource?.loading && items.length < 1\">\n    <p mat-line>{{ config.labels.noResults }}</p>\n  </mat-list-item>\n  <mat-list-item class=\"loading\" *ngIf=\"dataSource?.loading\">\n    <mat-spinner diameter=\"24\"></mat-spinner>\n  </mat-list-item>\n  <mat-list-item class=\"load-more\" *ngIf=\"items.length > 0 && items.length < dataSource?.maxCount\">\n    <button mat-button (click)=\"nextPage()\" [disabled]=\"dataSource?.loading\">\n      {{ config.actions.showMore.label }}\n    </button>\n  </mat-list-item>\n</mat-list>\n",
                styles: [".ant-list-view{width:100%;max-width:100%;height:100%;max-height:100%;overflow:auto}.ant-list-view .loading{width:100%;display:flex;justify-content:center}.ant-list-view .load-more,.ant-list-view .load-more button{width:100%}.ant-list-view .no-results{width:100%;text-align:center}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ANT_UI_CONFIG]
            }] }]; }, { dataSource: [{
            type: Input
        }], templateRef: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MaterialModule, { imports: [MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDividerModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatLineModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSortModule,
        MatTableModule], exports: [MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDividerModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatLineModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSortModule,
        MatTableModule] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MaterialModule, [{
        type: NgModule,
        args: [{
                imports: modules,
                exports: modules
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColumnSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'ant-column-selection',
                template: "<mat-form-field>\n  <mat-label>{{ label }}</mat-label>\n  <mat-select #select\n              [ngModel]=\"visibleColumns\"\n              (ngModelChange)=\"onSelectionChange($event)\"\n              multiple\n  >\n    <mat-option *ngFor=\"let name of availableColumns\" [value]=\"name\">{{name}}</mat-option>\n  </mat-select>\n</mat-form-field>\n",
                styles: ["mat-form-field{width:100%;box-sizing:border-box;overflow:hidden}"]
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }], columnHolder: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AntUiModule, { declarations: function () { return [ButtonComponent,
        ListViewComponent,
        TableViewComponent,
        GridViewComponent,
        GridTemplateDirective,
        ColumnSelectionComponent]; }, imports: function () { return [CommonModule,
        FormsModule, ɵngcc6.TranslateModule, MaterialModule]; }, exports: function () { return [ButtonComponent,
        ListViewComponent,
        TableViewComponent,
        GridViewComponent,
        GridTemplateDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AntUiModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ButtonComponent,
                    ListViewComponent,
                    TableViewComponent,
                    GridViewComponent,
                    GridTemplateDirective,
                    ColumnSelectionComponent
                ],
                providers: [
                    { provide: ANT_UI_CONFIG, useValue: ɵ0 },
                    StorageService
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule.forChild(),
                    MaterialModule
                ],
                exports: [
                    ButtonComponent,
                    ListViewComponent,
                    TableViewComponent,
                    GridViewComponent,
                    GridTemplateDirective
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of ant-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ANT_UI_CONFIG, ANT_UI_DEFAULT_BUTTON_CONFIG, AntDataSource, AntFilterDataSource, AntSortDataSource, AntUiModule, BaseDataSource, ButtonComponent, DEFAULT_ANT_UI_CONFIG, GridTemplateDirective, GridViewComponent, ListViewComponent, TableViewComponent, ɵ0, StorageService as ɵa, ColumnSelectionComponent as ɵb, modules as ɵc, MaterialModule as ɵd };

//# sourceMappingURL=antony-ng-ui.js.map